import { useCallback, useEffect, useState } from 'react';
import { callCenterSubjectsApi } from '../../../utils/api';

/**
 * کش اشتراکی لیست موضوعات: همه Selectها و چیپ‌های یک صفحه (مثلاً هر ردیف جدول تماس‌ها) با یک درخواست کار می‌کنند.
 */
let cache = null;
let inflight = null;
const listeners = new Set();

const notify = () => listeners.forEach((listener) => listener(cache));

const fetchSubjects = async () => {
  if (!inflight) {
    inflight = callCenterSubjectsApi.getAll()
      .then((res) => {
        const payload = res?.data ?? [];
        // آرایه تازه تا React حتماً تغییر را تشخیص دهد
        cache = [...(Array.isArray(payload) ? payload : payload.data ?? [])];
        notify();
        return cache;
      })
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
};

/** پس از هر تغییر CRUD فراخوانی شود تا همه کامپوننت‌ها لیست تازه را بگیرند */
export const refreshCallSubjects = () => fetchSubjects();

export const useCallSubjects = () => {
  const [subjects, setSubjects] = useState(cache || []);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    const listener = (next) => setSubjects(next || []);
    listeners.add(listener);

    if (!cache) {
      fetchSubjects()
        .catch(() => {})
        .finally(() => setLoading(false));
    }

    return () => listeners.delete(listener);
  }, []);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      await fetchSubjects();
    } finally {
      setLoading(false);
    }
  }, []);

  return { subjects, loading, reload };
};

export default useCallSubjects;
